import { useMutation } from '@tanstack/react-query';

import { DispatchEventClient, FlightEventFlightDetailsLookup } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const dispatchEventClient = new DispatchEventClient(apiBaseUrl);

function useCreateNewDispatchEvent() {
  return useMutation({
    mutationKey: [queryKeys.DispatchEvent.CreateNew],
    mutationFn: (lookup: FlightEventFlightDetailsLookup) => dispatchEventClient.createNew(lookup),
  });
}

export default useCreateNewDispatchEvent;
